import { type Dispatch, useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { CardFieldsContainer } from 'payments/components/CardFieldsContainer';
import { useClover } from 'payments/hooks/useCloverV2';
import { CloverPaymentFormProvider } from 'payments/providers/CloverPaymentFormProvider';
import { useModal } from 'reservations/base/providers/ModalProvider';

export const NewCardForm = ({
  setHandleSaveCard
}: {
  setHandleSaveCard: Dispatch<() => void>;
}) => {
  const { cardFieldStates, handleCardSubmit, setCardFieldStates } = useClover();
  const {
    modalContext: { cardDeclinedError }
  } = useModal();
  const date = useWatch({
    name: 'date'
  });

  useEffect(() => {
    setHandleSaveCard(() => handleCardSubmit);
  }, [handleCardSubmit]);

  return (
    <CloverPaymentFormProvider
      bookingDate={date}
      handleCardSubmit={handleCardSubmit}
      setCardFieldStates={setCardFieldStates}
    >
      <CardFieldsContainer
        cardFieldStates={cardFieldStates}
        cardDeclinedError={cardDeclinedError}
      />
    </CloverPaymentFormProvider>
  );
};
